/**
 * Blog product cards: fill image / title / price from /products/{handle}.js
 * Markup in article HTML:
 *   <div class="wlk-product-card" data-product-handle="your-handle">...</div>
 */
(function () {
  if (window.__wlkProductCardsInit) return;
  window.__wlkProductCardsInit = true;

  function yen(cents) {
    if (cents == null || cents === '') return '';
    return '¥' + Math.round(Number(cents) / 100).toLocaleString('ja-JP');
  }

  function absUrl(pathOrUrl) {
    if (!pathOrUrl) return window.location.origin;
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
    if (pathOrUrl.indexOf('//') === 0) return window.location.protocol + pathOrUrl;
    return window.location.origin + (pathOrUrl.charAt(0) === '/' ? pathOrUrl : '/' + pathOrUrl);
  }

  function fillCard(card, product) {
    var productUrl = absUrl(product.url || '/products/' + product.handle);
    var imageUrl = absUrl(product.featured_image);
    var label = card.getAttribute('data-btn-label') || '商品を見る';
    var image = card.querySelector('[data-role="image"]');
    var titleLink = card.querySelector('[data-role="title-link"]');
    var mediaLink = card.querySelector('[data-role="link"]');
    var priceEl = card.querySelector('[data-role="price"]');
    var btn = card.querySelector('[data-role="button"]');
    var btnLabel = card.querySelector('[data-role="btn-label"]');

    if (image && imageUrl) {
      image.src = imageUrl;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
    }
    if (titleLink) {
      titleLink.textContent = product.title || '';
      titleLink.href = productUrl;
    }
    if (mediaLink) mediaLink.href = productUrl;
    if (btn) btn.href = productUrl;
    if (btnLabel) btnLabel.textContent = label;

    if (priceEl) {
      var priceHtml = '';
      if (product.compare_at_price && product.compare_at_price > product.price) {
        priceHtml += '<span class="compare">' + yen(product.compare_at_price) + '</span>';
      }
      priceHtml += '<span>' + yen(product.price) + '</span><span class="tax">（税込）</span>';
      priceEl.innerHTML = priceHtml;
    }

    card.classList.add('is-ready');
  }

  function loadCard(card) {
    var handle = (card.getAttribute('data-product-handle') || '').trim();
    if (!handle || card.classList.contains('is-ready')) return;

    card.classList.add('is-loading');

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      })
      .then(function (product) {
        fillCard(card, product);
        card.classList.remove('is-loading');
      })
      .catch(function () {
        card.classList.remove('is-loading');
        card.classList.add('is-error');
      });
  }

  function init() {
    document.querySelectorAll('.wlk-product-card[data-product-handle]').forEach(loadCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
